export const siteText = {
  firstWord: 'PERMANENT ',
  lastWord: 'PERMANENT ',
};